import { Box, Td, Text, Tooltip, Tr } from '@chakra-ui/react'
import { format } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'

export function ItemLayout({ layout, position }) {
  return (
    <Tooltip
      {...(layout.prioridade && {
        label: 'Prioridade de layout (Ana)',
        ariaLabel: 'A tooltip',
      })}
    >
      <Tr
        _hover={{
          bg: layout.prioridade ? 'red.200' : 'gray.200',
          cursor: 'pointer',
        }}
        bg={layout.prioridade ? 'red.100' : 'gray.50'}
      >
        <Td textAlign="center">
          <Box>
            <Text as="span" fontSize="sm">
              {layout.position} º
            </Text>
          </Box>
        </Td>
        <Td>
          <Box position="relative">
            <Text as="span" fontSize="sm">
              {format(
                new Date(layout.data_solicitacao),
                "'Dia' dd 'às' HH:mm",
                {
                  locale: ptBR,
                }
              )}
            </Text>
          </Box>
        </Td>
        <Td>
          <Text as="span" fontSize="sm">
            {layout.tipo_pedido}
          </Text>
        </Td>
        <Td>
          <Text as="span" fontSize="sm">
            {layout.numero_innovation}
          </Text>
        </Td>
        <Td>
          <Text as="span" fontSize="sm">
            {layout.referencia}
          </Text>
        </Td>
        <Td>
          <Text as="span" fontSize="sm" textTransform="capitalize">
            {layout.nome_vendedor.toLowerCase()}
          </Text>
        </Td>
        <Td>
          <Text as="span" fontSize="sm" textTransform="capitalize">
            {layout.descricao_produto.toLowerCase()}
          </Text>
        </Td>
        <Td>
          <Text as="span" fontSize="sm" textTransform="capitalize">
            {layout.cor.toLowerCase()}
          </Text>
        </Td>
        <Td>
          <Text as="span" fontSize="sm">
            {layout.tipo_gravacao}
          </Text>
        </Td>
        <Td>
          <Text as="span" fontSize="sm">
            {layout.prazo_entrega}
          </Text>
        </Td>
        <Tooltip
          label={layout.observacoes}
          aria-label="A tooltip"
          placement="top"
        >
          <Td>
            <Text as="span" fontSize="sm">
              {layout.observacoes
                ? layout.observacoes.substring(0, 3).concat('...')
                : 'Sem obs'}
            </Text>
          </Td>
        </Tooltip>

        <Td textAlign="center">
          <Text as="span" fontSize="sm">
            {layout.quantidade_batidas}
          </Text>
        </Td>
      </Tr>
    </Tooltip>
  )
}
